import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useId } from '../../internal/hooks';
import { useControllableState } from '../../internal/hooks/useControllableState';
import { DIALOG_NAME } from './constants';
import { DialogProvider } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export var DialogRoot = function DialogRoot(props) {
  var __scopeDialog = props.__scopeDialog,
    children = props.children,
    openProp = props.open,
    defaultOpen = props.defaultOpen,
    onOpenChange = props.onOpenChange,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? true : _props$modal;
  var triggerRef = React.useRef(null);
  var contentRef = React.useRef(null);
  var _useControllableState = useControllableState({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    _useControllableState3 = _useControllableState2[0],
    open = _useControllableState3 === void 0 ? false : _useControllableState3,
    setOpen = _useControllableState2[1];
  return /*#__PURE__*/_jsx(DialogProvider, {
    scope: __scopeDialog,
    triggerRef: triggerRef,
    contentRef: contentRef,
    contentId: useId(undefined),
    titleId: useId(undefined),
    descriptionId: useId(undefined),
    open: open,
    onOpenChange: setOpen,
    onOpenToggle: React.useCallback(function () {
      return setOpen(function (prevOpen) {
        return !prevOpen;
      });
    }, [setOpen]),
    modal: modal,
    children: children
  });
};
DialogRoot.displayName = DIALOG_NAME;